import React from 'react';
import {Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function SpiritualityGoalActions() {
  const goal = useNamedSelector('clarity.goals', { category: 'spiritual-life' });
  const activities = useNamedSelector('clarity.activities', { category: 'spiritual-life' });
  return (
    <List tiny-gutter>
      <p>Come up with one thing you would like to change in your spiritual life (e.g. pray more often, attend religious services, connect with the Creator, etc.) and make it a goal.</p>
      <Edit value={goal.name} setValue={goal.update} />
      <List.Title>With your goal in mind, what is one thing you can commit to doing over the next month to reach that goal? Plan it and commit to doing it.</List.Title>
      <Edit name="0" value={activities.first} setValue={activities.update} />
      <Edit name="1" value={activities.second} setValue={activities.update} />
    </List>
  );
}
